import { z } from "zod";

export const batchCosignSchema = z.object({
  isConfirmed: z.boolean().refine((v) => v, "You must confirm before co-signing"),
});

export type BatchCosignFormValues = z.infer<typeof batchCosignSchema>;

export const batchRejectSchema = z.object({
  rejectionReason: z
    .string()
    .min(1, "Rejection reason is required")
    .max(1500, "Rejection reason cannot exceed 1500 characters"),
});

export type BatchRejectFormValues = z.infer<typeof batchRejectSchema>;
